import React, { useEffect, useState, useRef } from 'react';
import { FeedTabs } from '../components/feed/FeedTabs';
import { VideoCard } from '../components/feed/VideoCard';
import { CommentsSheet } from '../components/sheets/CommentsSheet';
import { ShareSheet } from '../components/sheets/ShareSheet';
import { MOCK_VIDEOS } from '../data/mockData';
export function Feed() {
  const [activeTab, setActiveTab] = useState('For You');
  const [activeVideoIndex, setActiveVideoIndex] = useState(0);
  const [isCommentsOpen, setIsCommentsOpen] = useState(false);
  const [isShareOpen, setIsShareOpen] = useState(false);
  const containerRef = useRef<HTMLDivElement>(null);
  // Handle scroll snapping to determine active video
  const handleScroll = () => {
    if (!containerRef.current) return;
    const {
      scrollTop,
      clientHeight
    } = containerRef.current;
    const index = Math.round(scrollTop / clientHeight);
    if (index !== activeVideoIndex) {
      setActiveVideoIndex(index);
    }
  };
  return <div className="w-full h-full relative bg-black" data-id="element-393">
      <FeedTabs activeTab={activeTab} setActiveTab={setActiveTab} data-id="element-394" />

      {/* Video Container */}
      <div ref={containerRef} onScroll={handleScroll} className="w-full h-full overflow-y-scroll snap-y-mandatory no-scrollbar" data-id="element-395">
        {MOCK_VIDEOS.map((video, index) => <VideoCard key={video.id} video={video} isActive={index === activeVideoIndex} onOpenComments={() => setIsCommentsOpen(true)} onOpenShare={() => setIsShareOpen(true)} data-id="element-396" />)}
      </div>

      {/* Modals */}
      <CommentsSheet isOpen={isCommentsOpen} onClose={() => setIsCommentsOpen(false)} data-id="element-397" />
      <ShareSheet isOpen={isShareOpen} onClose={() => setIsShareOpen(false)} data-id="element-398" />
    </div>;
}